import { ThemeProvider } from '@mui/material';
import './App.css';
import { Routes } from './Routes';

import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from './store/store';
import { SnackbarProvider } from 'notistack';
import ErrorAlert from './Main/Components/Common/ErrorAlert';
import SuccessAlert from './Main/Components/Common/SuccessAlert';
import ScrollToTop from './utils/ScrollToTop';
import { HelmetProvider } from 'react-helmet-async';
import CookieModal from './Main/Components/Cookies/CookieModal';
import { Theme } from './Themes';
import { useEffect } from 'react';
import { trackReferral, saveReferralData } from './utils/trackReferral';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

function App() {
  const helmetContext = {};

  useEffect(() => {
    // Track referral source on app load
    const referralData = trackReferral();

    // Only save if there's a source
    if (referralData.source || referralData.referrer) {
      saveReferralData(referralData);
    }
  }, []);

  const queryClient = new QueryClient();

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <HelmetProvider context={helmetContext}>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <ThemeProvider theme={Theme}>
                <SnackbarProvider
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  Components={{ error: ErrorAlert, success: SuccessAlert }}
                  maxSnack={3}
                >
                  <CookieModal />
                  <Routes />
                  <ScrollToTop />
                </SnackbarProvider>
              </ThemeProvider>
            </PersistGate>
          </Provider>
        </HelmetProvider>
      </QueryClientProvider>
    </>
  );
}

export default App;
